/**
=========================================================
* Iris Design Limited  Fulfilment POD - v2.2.0
=========================================================

* Product Page: https://www.irisdesignlimited.com/product/material-dashboard-react
* Copyright 2023 Dev Iris Design Limited Company (https://www.irisdesignlimited.com)

Coded by www.irisdesignlimited.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Switch, TextField } from '@mui/material';
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useDropzone } from 'react-dropzone';
// Iris Design Limited  Fulfilment POD example components
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import NoteCell from 'examples/NoteCell';
import SizeHtml, { sizeHasHtml } from 'components/SizeHtml';
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import HTMLDataTable from "examples/Tables/HTMLDataTable";
import "react-datepicker/dist/react-datepicker.css";
// Data
import MDPageBar from 'components/MDPagination/MDPageBar';
import { deleteDesign, editOrder, getOrders, uploadDesign } from "features/slices";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import bcrypt from 'bcryptjs';
import NoteDialog from 'examples/NoteDialog';
import { receiveDesign, setLoading, updateLoading } from 'features/slices';
import { newLink } from 'features/slices';
import { updateCurrentPage } from 'features/slices';
import { NotificationManager } from 'react-notifications';
import { styled } from '@mui/system';

const Section = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(1),
}));

const GreenSection = styled(Section)({
});

const BlueSection = styled(Section)({
  background: 'linear-gradient(195deg, #9dbdba, #9dbdba)',
  width: "100%",
  display: "flex",
  flexDirection: "row"
});

const DarkSection = styled(Section)({
  background: 'linear-gradient(195deg, #42424a, #191919)',
});

const CaptionText = styled('p')({
  display: "flex",
  flexDirection: "row",
  fontWeight: 'bold',
  marginTop: 4,
  fontSize: "14px",
  color: "#1E293B",
});

const CaptionText2 = styled('p')({
  fontWeight: 'bold',
  marginTop: 4,
  color: "white",
  fontSize: "14px",
});

const InfoText = styled('span')({
  marginLeft: 5,
  color: "#1E293B"
});

const NormalText = styled('span')({
  fontWeight: '400',
  marginLeft: 5,
  color: 'inherit',
});

const HighlightedText = styled('span')({
  fontWeight: '500',
  color: 'orange',
  marginLeft: 5,
  fontSize: "14px"
});

const RedText = styled('span')({
  color: 'red',
  fontWeight: 'bold',
});

function Tables() {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.user.data || []);
  const permission = useSelector((state) => state.user.permission || []);
  const user = useSelector((state) => state.user.user);
  const filterStore = useSelector((state) => state.user.filterStore);
  const order_status = useSelector((state) => state.user.order_status);
  const startDate = useSelector((state) => state.user.startDate);
  const search = useSelector((state) => state.user.search);
  const currentPage = useSelector((state) => state.user.currentPage) || 1;
  const type2 = useSelector((state) => state.user.type);
  const endDate = useSelector((state) => state.user.endDate);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [itemEditor, setItemEditor] = useState({})
  const [designLink, setDesignLink] = useState([])
  const [imageFront, setImageFront] = useState("");
  const [imageBack, setImageBack] = useState("");
  const [type, setType] = useState(false);
  const [exist, setExits] = useState(false);
  const [asyncDesign, setAsyncDesign] = useState(false);
  const [alert, setAlert] = useState(false);
  const [note, setNote] = useState("");
  const [frontImageLink, setFrontImageLink] = useState("");
  const [backImageLink, setBackImageLink] = useState("");
  function getGoogleDriveFileId(url) {
    const regex = /\/d\/([^\/]+)/;
    const match = url.match(regex);
    return match ? `https://drive.usercontent.google.com/download?id=${match[1]}` : null;
  }
  const handleLinkSubmit = async (side, link) => {
    try {
      let linkConvert = link.replace(/,/g, "%2C")
      if (link.includes("drive.google")) {
        linkConvert = getGoogleDriveFileId(link)
      }
      const rest2 = await dispatch(newLink({ urls: linkConvert }))
      linkConvert = rest2.payload?.[0]
      dispatch(setLoading(true))
      const response = await fetch(linkConvert);
      const blob = await response.blob();
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = btoa(reader.result);
        if (side === "front") {
          setImageFront([base64String]);
        } else if (side === "back") {
          setImageBack([base64String]);
        }
      };
      reader.readAsBinaryString(blob);
    } catch (error) {
      console.error("Error fetching image:", error);
    }
    dispatch(setLoading(false))
  };
  const handleDeleteNote = async (index) => {
    const updatedNotes = itemEditor.note.split("\n").filter((_, i) => i !== index);
    const res = await dispatch(editOrder({ user, field: "note", string: updatedNotes.join("\n"), id: itemEditor.id }))
    if (res.payload.status == 0) {
      // await dispatch(
      //   getOrders({
      //     store: filterStore, order_status,
      //     startDate: moment(startDate).startOf("day").format("x"),
      //     endDate: moment(endDate).endOf("day").format("x"), currentPage, search
      //   })
      // );
      bcrypt.genSalt(10, (err, salt) => {
        bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
          const time = moment().unix()
          const res = await dispatch(getOrders({
            store: filterStore, order_status,
            startDate: moment(startDate).startOf("day").format("x"),
            endDate: moment(endDate).endOf("day").format("x"),
            currentPage,
            search,
            version: hash,
            type: type2
          }))

        });
      })
    }
    setOpen2(false)
  };
  const handleChangePage = async (newPage) => {
    await dispatch(updateCurrentPage(newPage))
  };

  const handleUploadDesign = async () => {
    let newEditor = { front: "", back: "" }
    if (imageFront && imageBack) {
      newEditor.back = imageBack
      newEditor.front = imageFront
    } else if (imageBack) {
      newEditor.back = imageBack
      newEditor.front = itemEditor.design_link?.front
    } else if (imageFront) {
      newEditor.front = imageFront
      newEditor.back = itemEditor.design_link?.back
    }
    const res = await dispatch(uploadDesign({ urls: newEditor, id: itemEditor.id, link: itemEditor.link, design: itemEditor.design_link || [], user: exist ? "" : user, product_name: itemEditor.product_name, type, async_design: asyncDesign, images: itemEditor.images, alert }));
    if (res.payload.status == 0) {
      setOpen(false);
      // await dispatch(
      //   getOrders({
      //     store: filterStore, order_status,
      //     startDate: moment(startDate).startOf("day").format("x"),
      //     endDate: moment(endDate).endOf("day").format("x"), currentPage, search
      //   })
      // );
      bcrypt.genSalt(10, (err, salt) => {
        bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
          const time = moment().unix()
          const res = await dispatch(getOrders({
            store: filterStore, order_status,
            startDate: moment(startDate).startOf("day").format("x"),
            endDate: moment(endDate).endOf("day").format("x"),
            currentPage,
            search,
            version: hash,
            type: type2
          }))

        });
      })
    }
    setExits(false)
    setAsyncDesign(false)
    setOpen(false)
  };

  const handleAddDesign = async (item) => {
    setImageBack("")
    setImageFront("")
    setDesignLink(item.design_link)
    setItemEditor(item)
    setOpen(true)
  }

  const handleChangeNote = async (e) => {
    const res = await dispatch(editOrder({ user, field: "note", string: !itemEditor.note ? `${user.replace("@gmail.com", "")}: ${note}` : `${itemEditor.note}\n${user.replace("@gmail.com", "")}:${note}`, id: itemEditor.id }))
    if (res.payload.status == 0) {

      // bcrypt.genSalt(10, (err, salt) => {
      //   bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
      //     const time = moment().unix()
      //     const res = await dispatch(getOrders({
      //       store: filterStore, order_status,
      //       startDate: moment(startDate).startOf("day").format("x"),
      //       endDate: moment(endDate).endOf("day").format("x"),
      //       currentPage,
      //       search,
      //       version: hash,
      //     }))

      //   });
      // })
    }
    setOpen2(false)
  }

  const handleAddNote = (item) => {
    setNote("")
    setItemEditor(item)
    setOpen2(true)
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  const handleShowInformation = (item) => {
    setItemEditor(item);
    setOpen4(true);
  };

  const handleClose4 = () => {
    setOpen4(false);
  };

  const handleType = (value) => {
    setType(value);
    setImageBack("")
  };



  const handleDelete = async (index) => {
    let newDesignLink = designLink;
    if (index == "front") {
      newDesignLink = { front: "", back: itemEditor.design_link.back }
    } else {
      newDesignLink = { front: itemEditor.design_link.front, back: "" }
    }
    setDesignLink(newDesignLink)
    const res = await dispatch(deleteDesign({ design_link: newDesignLink, id: itemEditor.id, link: itemEditor.link, user }))
    if (res.payload.status == 0) {
      let newItemEditor = { ...itemEditor, design_link: newDesignLink };
      setItemEditor(newItemEditor)
      // await dispatch(
      //   getOrders({
      //     store: filterStore, order_status,
      //     startDate: moment(startDate).startOf("day").format("x"),
      //     endDate: moment(endDate).endOf("day").format("x"), currentPage, search
      //   })
      // );
      bcrypt.genSalt(10, (err, salt) => {
        bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
          const time = moment().unix()
          const res = await dispatch(getOrders({
            store: filterStore, order_status,
            startDate: moment(startDate).startOf("day").format("x"),
            endDate: moment(endDate).endOf("day").format("x"),
            currentPage,
            search,
            version: hash,
          }))

        });
      })
    }
  }
  const onDropFront = (acceptedFiles) => {
    const file = acceptedFiles[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      const base64String = btoa(event.target.result);
      setImageFront([base64String]);
    };

    reader.readAsBinaryString(file);
  };

  const handleReceiveDesign = async (items) => {
    await dispatch(receiveDesign({ id: items, user }))
    // await dispatch(
    //   getOrders({
    //     store: filterStore, order_status,
    //     startDate: moment(startDate).startOf("day").format("x"),
    //     endDate: moment(endDate).endOf("day").format("x"),
    //     currentPage, search
    //   })
    // );
    bcrypt.genSalt(10, (err, salt) => {
      bcrypt.hash(`${user}đố tuấn anh phá được`, salt, async (err, hash) => {
        const time = moment().unix()
        const res = await dispatch(getOrders({
          store: filterStore, order_status,
          startDate: moment(startDate).startOf("day").format("x"),
          endDate: moment(endDate).endOf("day").format("x"),
          currentPage,
          search,
          version: hash,
        }))

      });
    })
  }

  const onDropBack = (acceptedFiles) => {
    const file = acceptedFiles[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      const base64String = btoa(event.target.result);
      setImageBack([base64String]);
    };

    reader.readAsBinaryString(file);
  };

  function getFirstWords(text) {
    if (text && text.length > 35) {
      return text.substring(0, 35) + "...";
    } else {
      return text || "";
    }
  }
  const { getRootProps: getRootPropsFront, getInputProps: getInputPropsFront } = useDropzone({
    onDrop: onDropFront, accept: {
      'image/*': ['.jpeg', '.jpg', '.png'],
    },
  });
  const { getRootProps: getRootPropsBack, getInputProps: getInputPropsBack } = useDropzone({
    onDrop: onDropBack, accept: {
      'image/*': ['.jpeg', '.jpg', '.png'],
    },
  });
  const capitalizeAndColorBeforeColon = (note) => {
    const lines = note.split('\n');
    const totalLines = lines.length;
    const linesToShow = 3;

    const displayLines = totalLines > linesToShow
      ? ['...'].concat(lines.slice(totalLines - linesToShow))
      : lines;

    return displayLines.map((line, index) => {
      const [beforeColon, afterColon] = line.split(':', 2);
      const capitalizedBeforeColon = beforeColon.trim().charAt(0).toUpperCase() + beforeColon.trim().slice(1);
      return (
        <div key={index} style={{ marginBottom: index < displayLines.length - 1 ? '4px' : '0' }}>
          <span style={{
            color: '#d32f2f',
            fontWeight: 600,
            fontSize: '11px'
          }}>{capitalizedBeforeColon}</span>
          <span style={{ color: '#666', marginLeft: '3px' }}>: {afterColon ? afterColon.trim() : ""}</span>
        </div>
      );
    });
  };


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ paddingTop: '24px', paddingBottom: '24px' }}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <div style={{ paddingTop: '24px' }}>
                <HTMLDataTable
                  table={{
                    columns: [
                      { Header: "Date", accessor: "date", align: "left" },
                      { Header: "Order Id", accessor: "order_id", align: "left" },
                      { Header: "Name", accessor: "items_name", align: "left" },
                      { Header: "Variation", accessor: "variation", align: "left" },
                      { Header: "Note", accessor: "note", align: "left" },
                      { Header: "Design", accessor: "design", align: "left" },
                    ],
                    rows: data.data && data.data.length > 0 ? [...data.data.map((items, index) => ({
                      order_status: items.error_order,
                      id: items.order_id,
                      cancel: items.tracking,
                      itemEditor: itemEditor.order_id,
                      date: <>
                        {items.price || search ? <span className={items?.price > 0 ? "tc-text" : "tc-muted"}>{moment(items.date).format("HH:mm DD/MM")}</span> : ""}
                      </>,
                      order_id: <>
                        {items.price || search ? (
                          <div className="tc-stack">
                            <p className={items.price ? "tc-text" : "tc-muted"}>{items.order_id}</p>
                            <div className="tc-row">
                              {items?.store_name == "Sesverin" || items?.store_name == "Navlak" || items?.store_name == "Ladyjacket" || items?.store_name == "Atorcus" || items?.store_name == "Prashirt" || items?.store_name == "Thalath" ?
                                <img src="https://egead.nyc3.digitaloceanspaces.com/1728270648803h7puf0.jpg" alt="" style={{ height: 16, borderRadius: 3 }} />
                                : null}
                              <p className="tc-muted">{items.store_name}</p>
                              <button type="button" className="tc-icon-btn" onClick={() => handleShowInformation(items)} title="Order info"><InfoOutlinedIcon /></button>
                            </div>
                          </div>
                        ) : ""}
                      </>,
                      items_name: (
                        <a href={items.link} target="_blank" rel="noopener noreferrer" className="tc-link">
                          {getFirstWords(items.items_name)}
                        </a>
                      ),
                      variation: (
                        <div className="tc-row" style={{ flexWrap: "wrap" }}>
                          <span className="tc-size">{sizeHasHtml(items.size) ? <SizeHtml value={items.size} /> : items.size.replace("Type: ", "").replace("Fabric Brand: ", "").replace("Style: ", "").replace("Size: ", "").replace("Product Sides Options: ", "")}</span>
                          <span className="tc-chip tc-chip--danger">{items.color}</span>
                        </div>
                      ),
                      note: (
                        <NoteCell
                          customerNote={items.price ? items.customer_note : ""}
                          note={items.note}
                          canEdit={permission.includes("note")}
                          onAdd={() => handleAddNote(items)}
                        />
                      ),
                      design: (
                        <div style={{ display: "flex", flexDirection: "row", gap: "6px", flexWrap: "wrap" }}>
                          {user == items.design || permission.includes("design_link") ? (
                            <>
                              {items?.design_link ? (
                                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                  {items?.design_link?.front ? items?.design_link?.front == "upload" ? (
                                    <span style={{
                                      fontSize: '0.75rem',
                                      fontWeight: 600,
                                      color: '#ff9800'
                                    }}>Uploading</span>
                                  ) : (
                                    <a
                                      key={0}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      href={items?.design_link.front}
                                      style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '4px',
                                        color: '#1976d2',
                                        textDecoration: 'none',
                                        transition: 'opacity 0.2s ease'
                                      }}
                                      onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                                      onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                                      title="Front Design"
                                    >
                                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="3" y="3" width="18" height="18" rx="2" stroke="#1976d2" strokeWidth="2" fill="none" />
                                        <line x1="3" y1="9" x2="21" y2="9" stroke="#1976d2" strokeWidth="2" />
                                        <circle cx="7" cy="6" r="1" fill="#1976d2" />
                                        <circle cx="10" cy="6" r="1" fill="#1976d2" />
                                        <circle cx="13" cy="6" r="1" fill="#1976d2" />
                                      </svg>
                                      <span style={{ fontSize: '0.75rem' }}>Front</span>
                                    </a>
                                  ) : null}
                                  {items?.design_link?.back ? (
                                    <a
                                      key={1}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      href={items?.design_link.back}
                                      style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '4px',
                                        color: '#1976d2',
                                        textDecoration: 'none',
                                        transition: 'opacity 0.2s ease'
                                      }}
                                      onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                                      onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                                      title="Back Design"
                                    >
                                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="3" y="3" width="18" height="18" rx="2" stroke="#1976d2" strokeWidth="2" fill="none" />
                                        <line x1="3" y1="15" x2="21" y2="15" stroke="#1976d2" strokeWidth="2" />
                                        <circle cx="7" cy="18" r="1" fill="#1976d2" />
                                        <circle cx="10" cy="18" r="1" fill="#1976d2" />
                                        <circle cx="13" cy="18" r="1" fill="#1976d2" />
                                      </svg>
                                      <span style={{ fontSize: '0.75rem' }}>Back</span>
                                    </a>
                                  ) : null}
                                </div>
                              ) : null}
                              {permission.includes("design_link") && !items.tracking && !items.status_fulfil ? (
                                <button
                                  onClick={() => handleAddDesign(items)}
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    padding: '4px 10px',
                                    fontSize: '0.7rem',
                                    fontWeight: 600,
                                    color: '#fff',
                                    backgroundColor: '#f44336',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease'
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#d32f2f';
                                    e.currentTarget.style.transform = 'scale(1.05)';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = '#f44336';
                                    e.currentTarget.style.transform = 'scale(1)';
                                  }}
                                >
                                  Edit
                                </button>
                              ) : null}
                            </>
                          ) : !items.design && !items.design_link && !items.tracking && !items.status_fulfil && permission.includes("design_link") ? (
                            <button
                              onClick={() => handleReceiveDesign(items.id)}
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px',
                                padding: '4px 10px',
                                fontSize: '0.7rem',
                                fontWeight: 600,
                                color: '#fff',
                                backgroundColor: '#ff9800',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease'
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#f57c00';
                                e.currentTarget.style.transform = 'scale(1.05)';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#ff9800';
                                e.currentTarget.style.transform = 'scale(1)';
                              }}
                            >
                              Receive
                            </button>
                          ) : !items.tracking && !items.status_fulfil ? (
                            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                              {items?.design_link ? (
                                <>
                                  {items?.design_link?.front ? items?.design_link?.front == "upload" ? (
                                    <span style={{
                                      fontSize: '0.75rem',
                                      fontWeight: 600,
                                      color: '#ff9800'
                                    }}>Uploading</span>
                                  ) : (
                                    <a
                                      key={0}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      href={items?.design_link.front}
                                      style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '4px',
                                        color: '#1976d2',
                                        textDecoration: 'none',
                                        transition: 'opacity 0.2s ease'
                                      }}
                                      onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                                      onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                                      title="Front Design"
                                    >
                                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="3" y="3" width="18" height="18" rx="2" stroke="#1976d2" strokeWidth="2" fill="none" />
                                        <line x1="3" y1="9" x2="21" y2="9" stroke="#1976d2" strokeWidth="2" />
                                        <circle cx="7" cy="6" r="1" fill="#1976d2" />
                                        <circle cx="10" cy="6" r="1" fill="#1976d2" />
                                        <circle cx="13" cy="6" r="1" fill="#1976d2" />
                                      </svg>
                                      <span style={{ fontSize: '0.75rem' }}>Front</span>
                                    </a>
                                  ) : null}
                                  {items?.design_link?.back ? (
                                    <a
                                      key={1}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      href={items?.design_link.back}
                                      style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '4px',
                                        color: '#1976d2',
                                        textDecoration: 'none',
                                        transition: 'opacity 0.2s ease'
                                      }}
                                      onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                                      onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                                      title="Back Design"
                                    >
                                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="3" y="3" width="18" height="18" rx="2" stroke="#1976d2" strokeWidth="2" fill="none" />
                                        <line x1="3" y1="15" x2="21" y2="15" stroke="#1976d2" strokeWidth="2" />
                                        <circle cx="7" cy="18" r="1" fill="#1976d2" />
                                        <circle cx="10" cy="18" r="1" fill="#1976d2" />
                                        <circle cx="13" cy="18" r="1" fill="#1976d2" />
                                      </svg>
                                      <span style={{ fontSize: '0.75rem' }}>Back</span>
                                    </a>
                                  ) : null}
                                </>
                              ) : (
                                <span className="caption-text" style={{ color: "orange" }}>{items?.design ? `***${items?.design.replace("@gmail.com", "").substring(items?.design.replace("@gmail.com", "").length - 7)}` : ""}</span>
                              )}
                            </div>
                          ) : (
                            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                              {items?.design_link?.front ? items?.design_link?.front == "upload" ? (
                                <span style={{
                                  fontSize: '0.75rem',
                                  fontWeight: 600,
                                  color: '#ff9800'
                                }}>Uploading</span>
                              ) : (
                                <a
                                  key={0}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href={items?.design_link.front}
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    color: '#1976d2',
                                    textDecoration: 'none',
                                    transition: 'opacity 0.2s ease'
                                  }}
                                  onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                                  onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                                  title="Front Design"
                                >
                                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="3" y="3" width="18" height="18" rx="2" stroke="#1976d2" strokeWidth="2" fill="none" />
                                    <line x1="3" y1="9" x2="21" y2="9" stroke="#1976d2" strokeWidth="2" />
                                    <circle cx="7" cy="6" r="1" fill="#1976d2" />
                                    <circle cx="10" cy="6" r="1" fill="#1976d2" />
                                    <circle cx="13" cy="6" r="1" fill="#1976d2" />
                                  </svg>
                                  <span style={{ fontSize: '0.75rem' }}>Front</span>
                                </a>
                              ) : null}
                              {items?.design_link?.back ? items?.design_link?.back == "upload" ? (
                                <span style={{
                                  fontSize: '0.75rem',
                                  fontWeight: 600,
                                  color: '#ff9800'
                                }}>Uploading</span>
                              ) : (
                                <a
                                  key={1}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  href={items?.design_link.back}
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    color: '#1976d2',
                                    textDecoration: 'none',
                                    transition: 'opacity 0.2s ease'
                                  }}
                                  onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                                  onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                                  title="Back Design"
                                >
                                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="3" y="3" width="18" height="18" rx="2" stroke="#1976d2" strokeWidth="2" fill="none" />
                                    <line x1="3" y1="15" x2="21" y2="15" stroke="#1976d2" strokeWidth="2" />
                                    <circle cx="7" cy="18" r="1" fill="#1976d2" />
                                    <circle cx="10" cy="18" r="1" fill="#1976d2" />
                                    <circle cx="13" cy="18" r="1" fill="#1976d2" />
                                  </svg>
                                  <span style={{ fontSize: '0.75rem' }}>Back</span>
                                </a>
                              ) : null}
                            </div>
                          )}
                        </div>
                      ),
                    })
                    )] : []
                  }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', padding: '5px' }}>
                  <MDPageBar
                    totalPage={data.totalPage}
                    currentPage={currentPage}
                    onChange={handleChangePage}
                  />
                </div>
              </div>
            </Card>
          </Grid>
        </Grid>
      </div>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>Design Information</DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", flexDirection: type ? "column" : "row", gap: "20px", justifyContent: "center", alignItems: "flex-start" }}>
            <div style={{ position: "relative" }}>
              <div className="transparent-background"><img src={itemEditor.design_link?.front} width={300} /> </div>
              {permission.includes("design_link") && itemEditor.design_link?.front && !itemEditor.tracking ?
                <HighlightOffIcon style={{ color: "red", position: "absolute", top: 0, right: 0 }} fontSize="large" onClick={() => handleDelete("front")} />
                : null}
              {permission.includes("design_link") && !itemEditor.tracking ?
                <div style={{ textAlign: "center" }} >
                  <div {...getRootPropsFront()} style={dropzoneStyles}>
                    <input {...getInputPropsFront()} />
                    <h5 style={textStyles}>
                      Upload Front Side
                    </h5>
                  </div>
                  {imageFront && (
                    <img
                      src={`data:image/png;base64,${imageFront}`}
                      alt={`Uploaded`}
                      style={{ maxWidth: 100, maxHeight: 100 }}
                    />
                  )}
                  <div style={{ marginTop: 10, display: "flex", flexDirection: "row", gap: "8px", alignItems: "center" }}>
                    <TextField
                      type="text"
                      placeholder="Enter image link"
                      value={frontImageLink}
                      onChange={(e) => setFrontImageLink(e.target.value)}
                      style={{ width: "80%", backgroundColor: "white", borderRadius: "0.5rem" }}
                    />
                    <button
                      onClick={() => handleLinkSubmit("front", frontImageLink)}
                      style={{
                        padding: '6px 16px',
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        color: '#fff',
                        backgroundColor: '#1976d2',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#1565c0';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#1976d2';
                      }}
                    >
                      LOAD
                    </button>
                  </div>
                </div>
                : null}
            </div>
            {!type ? (
              <div style={{ position: "relative" }}>
                <div className="transparent-background"><img src={itemEditor.design_link?.back} width={300} /></div>
                {permission.includes("design_link") && itemEditor.design_link?.back && !itemEditor.tracking ?
                  <HighlightOffIcon style={{ color: "red", position: "absolute", top: 0, right: 0 }} fontSize="large" onClick={() => handleDelete("back")} />
                  : null}
                {permission.includes("design_link") && !itemEditor.tracking ?
                  <div style={{ textAlign: "center" }} >
                    <div {...getRootPropsBack()} style={dropzoneStyles}>
                      <input {...getInputPropsBack()} />
                      <h5 style={textStyles}>
                        Upload Back Side
                      </h5>
                    </div>
                    {imageBack && (
                      <img
                        src={`data:image/png;base64,${imageBack}`}
                        alt={`Uploaded`}
                        style={{ maxWidth: 100, maxHeight: 100 }}
                      />
                    )}
                    <div style={{ marginTop: 10, display: "flex", flexDirection: "row", gap: "8px", alignItems: "center" }}>
                      <TextField
                        type="text"
                        placeholder="Enter image link"
                        value={backImageLink}
                        onChange={(e) => setBackImageLink(e.target.value)}
                        style={{ width: "80%", backgroundColor: "white", borderRadius: "0.5rem" }}
                      />
                      <button
                        onClick={() => handleLinkSubmit("back", backImageLink)}
                        style={{
                          padding: '6px 16px',
                          fontSize: '0.75rem',
                          fontWeight: 600,
                          color: '#fff',
                          backgroundColor: '#1976d2',
                          border: 'none',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#1565c0';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#1976d2';
                        }}
                      >
                        LOAD
                      </button>
                    </div>
                  </div>
                  : null}
              </div>
            ) : null}
          </div>
          <DialogActions>
            <FormControlLabel
              sx={{ display: 'flex', alignItems: 'center', flexDirection: "row", margin: 0.5 }}
              control={<Switch checked={alert} onChange={(e) => setAlert(e.target.checked)} />}
              label="Large 2D Image"
            />
            <FormControlLabel
              sx={{ display: 'flex', alignItems: 'center', flexDirection: "row", margin: 0.5 }}
              control={<Switch checked={type} onChange={(e) => handleType(e.target.checked)} />}
              label="3D"
            />
            <FormControlLabel
              sx={{ display: 'flex', alignItems: 'center', flexDirection: "row", margin: 0.5 }}
              control={<Switch checked={exist} onChange={(e) => setExits(e.target.checked)} />}
              label="Reup Design"
            />
            <FormControlLabel
              sx={{ display: 'flex', alignItems: 'center', flexDirection: "row", margin: 0.5 }}
              control={<Switch checked={asyncDesign} onChange={(e) => setAsyncDesign(e.target.checked)} />}
              label="Asynchronous Design"
            />
            {imageBack || imageFront ? (
              <button
                onClick={() => handleUploadDesign()}
                style={{
                  padding: '10px 24px',
                  fontSize: '0.875rem',
                  fontWeight: 600,
                  color: '#fff',
                  backgroundColor: '#4caf50',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow: '0 2px 4px rgba(76, 175, 80, 0.3)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#43a047';
                  e.currentTarget.style.boxShadow = '0 4px 8px rgba(76, 175, 80, 0.4)';
                  e.currentTarget.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#4caf50';
                  e.currentTarget.style.boxShadow = '0 2px 4px rgba(76, 175, 80, 0.3)';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                Upload Design
              </button>
            ) : null}

          </DialogActions>
        </DialogContent>
      </Dialog>
      <Dialog open={open4} onClose={handleClose4}>
        <DialogTitle>Information</DialogTitle>
        <DialogContent>
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <GreenSection>
              <CaptionText>Order ID: <InfoText>{itemEditor.order_id}</InfoText></CaptionText>
              <CaptionText>Store: <InfoText>{itemEditor.store_name}</InfoText></CaptionText>
              <CaptionText>Payment Method: <div style={{ display: "flex", flexDirection: "row", marginLeft: 5 }}><img src={itemEditor.shield ? itemEditor.shield.includes("PayPal:") ? "https://egead.nyc3.digitaloceanspaces.com/pp.png" : itemEditor.shield.includes("Stripe:") ? "https://egead.nyc3.digitaloceanspaces.com/stripe.png" : "https://egead.nyc3.digitaloceanspaces.com/card.png" : "https://egead.nyc3.digitaloceanspaces.com/card.png"} style={{ height: 20, marginRight: 5 }}></img>{itemEditor.shield ? itemEditor.shield.replace("PayPal:", "").replace("Stripe:", "").replace("Stripe", "") : itemEditor.shield}</div></CaptionText>
            </GreenSection>
            <hr style={{ marginTop: 10, marginBottom: 10 }} />
            {data.data && data.data.length ? data.data.filter(item => item.order_id === itemEditor.order_id && item.store_name === itemEditor.store_name).map((items, index) => (
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", position: "relative" }} key={index} >
                <BlueSection >
                  <img src={items.images} style={{ width: "60px", objectFit: "contain", marginRight: "10px" }}></img>
                  <div>
                    <CaptionText>
                      <a href={items.link} target="_blank" rel="noopener noreferrer" style={{ marginLeft: 5, marginRight: "5px", fontWeight: '400' }}>{items.items_name}</a>
                    </CaptionText>
                    <CaptionText>
                      <NormalText>{sizeHasHtml(items.size) ? <SizeHtml value={items.size} /> : (items.size ? items.size.replace("Type: ", "").replace("Fabric Brand: ", "").replace("Style: ", "").replace("Size: ", "").replace("Product Sides Options: ", "") : "")} - <RedText>{items.color}</RedText></NormalText>
                    </CaptionText>
                  </div>
                </BlueSection>
                <span style={{ position: "absolute", top: -7, right: -9, background: "white", borderRadius: "100%", width: "25px", height: "25px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <strong style={{ color: "black" }}>{items.quantity}</strong>
                </span>
              </div>
            )) : null}
            <hr style={{ marginTop: 10, marginBottom: 10 }} />
            <DarkSection>
              <CaptionText2>
                Ship to: <NormalText><HighlightedText>{itemEditor.customer_name}</HighlightedText> - {itemEditor?.address ? `${itemEditor?.address[0]} ${itemEditor?.address[1]}, ${itemEditor?.address[2]}, ${itemEditor?.address[3]} ${itemEditor?.address[4]}, United States` : null}</NormalText>
              </CaptionText2>
              <CaptionText2>
                Email: <NormalText>{itemEditor.email}</NormalText>
              </CaptionText2>
              <CaptionText2>
                Customer Phone: <NormalText>{itemEditor.phone ? itemEditor.phone.includes("+1") ? itemEditor.phone : `+1 ${itemEditor.phone}` : ""}</NormalText>
              </CaptionText2>
            </DarkSection>
          </div>
        </DialogContent>
      </Dialog>
      <NoteDialog open2={open2} handleDeleteNote={handleDeleteNote} handleClose2={handleClose2} note2={note} note={itemEditor.note} user={user.replace("@gmail.com", "")} setNote={setNote} handleChangeNote={handleChangeNote} />
      <Footer />
    </DashboardLayout >
  );
}

const dropzoneStyles = {
  border: '2px dashed green',
  borderRadius: '4px',
  padding: '10px',
  marginTop: "5px",
  textAlign: 'center',
  cursor: 'pointer',
};

const textStyles = {
  color: '#888888',
};

export default Tables;
